// Configuration des URLs API selon l'environnement

/**
 * Détecte l'environnement actuel
 * @returns {'production' | 'preview' | 'development'}
 */
const getEnvironment = () => {
  // Développement local
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  }

  const hostname = window.location.hostname;

  // Staging : branche develop déployée sur Netlify (URL par défaut ou domaine custom)
  if (
    hostname === 'develop--gie-consultants.netlify.app' ||
    hostname.startsWith('develop.') ||
    process.env.REACT_APP_ENV === 'staging'
  ) {
    return 'staging';
  }

  // Preview Netlify (PRs, autres branches) → fonctions de production
  if (hostname.includes('--gie-consultants.netlify.app')) {
    return 'preview';
  }

  // Production
  return 'production';
};

/**
 * Retourne l'URL de base pour les fonctions Netlify
 */
const getNetlifyBaseUrl = () => {
  const env = getEnvironment();

  if (env === 'development') {
    return 'http://localhost:8888/.netlify/functions';
  }

  if (env === 'staging') {
    // Staging : utilise ses propres fonctions Netlify (URL relative = même domaine)
    return '/.netlify/functions';
  }

  if (env === 'preview') {
    // Preview (PRs) : utilise les fonctions de PRODUCTION Netlify
    return 'https://nimbus.ephyco.com/.netlify/functions';
  }

  // Production
  return 'https://nimbus.ephyco.com/.netlify/functions';
};

// URL de base pour les fonctions Netlify (légères)
export const NETLIFY_FUNCTIONS_BASE = getNetlifyBaseUrl();

// URLs des fonctions Netlify (légères)
export const NETLIFY_FUNCTIONS = {
  // Auth
  LOGIN: `${NETLIFY_FUNCTIONS_BASE}/login`,
  LOGOUT: `${NETLIFY_FUNCTIONS_BASE}/logout`,
  REGISTER: `${NETLIFY_FUNCTIONS_BASE}/register`,
  GET_CURRENT_USER: `${NETLIFY_FUNCTIONS_BASE}/getCurrentUser`,
  VERIFY_TOKEN: `${NETLIFY_FUNCTIONS_BASE}/verify-token`,
  FORGOT_PASSWORD: `${NETLIFY_FUNCTIONS_BASE}/forgot-password`,
  RESET_PASSWORD: `${NETLIFY_FUNCTIONS_BASE}/reset-password`,
  VALIDATE_RESET_TOKEN: `${NETLIFY_FUNCTIONS_BASE}/validate-reset-token`,

  // WebAuthn / Passkeys
  WEBAUTHN_REGISTER_OPTIONS: `${NETLIFY_FUNCTIONS_BASE}/webauthn-register-options`,
  WEBAUTHN_REGISTER_VERIFY: `${NETLIFY_FUNCTIONS_BASE}/webauthn-register-verify`,
  WEBAUTHN_AUTH_OPTIONS: `${NETLIFY_FUNCTIONS_BASE}/webauthn-auth-options`,
  WEBAUTHN_AUTH_VERIFY: `${NETLIFY_FUNCTIONS_BASE}/webauthn-auth-verify`,
  WEBAUTHN_LIST_PASSKEYS: `${NETLIFY_FUNCTIONS_BASE}/webauthn-list-passkeys`,

  // Users
  GET_USERS: `${NETLIFY_FUNCTIONS_BASE}/get-users`,
  CREATE_USER: `${NETLIFY_FUNCTIONS_BASE}/create-user`,
  UPDATE_USER: `${NETLIFY_FUNCTIONS_BASE}/update-user`,
  DELETE_USER: `${NETLIFY_FUNCTIONS_BASE}/delete-user`,

  // Airtable
  GET_FACTURES: `${NETLIFY_FUNCTIONS_BASE}/get-factures`,
  GET_FACTURE: `${NETLIFY_FUNCTIONS_BASE}/get-facture`,
  ADD_FACTURE: `${NETLIFY_FUNCTIONS_BASE}/add-facture`,
  UPDATE_FACTURE: `${NETLIFY_FUNCTIONS_BASE}/update-facture`,
  DELETE_FACTURE: `${NETLIFY_FUNCTIONS_BASE}/delete-facture`,

  GET_CHARGES: `${NETLIFY_FUNCTIONS_BASE}/get-charges`,
  ADD_CHARGE: `${NETLIFY_FUNCTIONS_BASE}/add-charge`,
  UPDATE_CHARGE: `${NETLIFY_FUNCTIONS_BASE}/update-charge`,
  DELETE_CHARGE: `${NETLIFY_FUNCTIONS_BASE}/delete-charge`,

  GET_TMP: `${NETLIFY_FUNCTIONS_BASE}/get-tmp`,
  ADD_TMP: `${NETLIFY_FUNCTIONS_BASE}/add-tmp`,
  UPDATE_TMP: `${NETLIFY_FUNCTIONS_BASE}/update-tmp`,
  DELETE_TMP: `${NETLIFY_FUNCTIONS_BASE}/delete-tmp`,

  GET_TEMPS: `${NETLIFY_FUNCTIONS_BASE}/get-temps`,
  ADD_TEMP: `${NETLIFY_FUNCTIONS_BASE}/add-temp`,
  UPDATE_TEMP: `${NETLIFY_FUNCTIONS_BASE}/update-temp`,
  DELETE_TEMP: `${NETLIFY_FUNCTIONS_BASE}/delete-temp`,

  // Email preview
  PREVIEW_EMAIL: `${NETLIFY_FUNCTIONS_BASE}/preview-email`,

  // Banking
  GET_BANK_CONNECTIONS: `${NETLIFY_FUNCTIONS_BASE}/getBankConnections`,
  CREATE_BANK_CONNECTION: `${NETLIFY_FUNCTIONS_BASE}/createBankConnection`,
  DELETE_BANK_CONNECTION: `${NETLIFY_FUNCTIONS_BASE}/deleteBankConnection`,
  GET_BANK_TRANSACTIONS: `${NETLIFY_FUNCTIONS_BASE}/getBankTransactions`,
  UPDATE_BANK_CONNECTION_USERS: `${NETLIFY_FUNCTIONS_BASE}/updateBankConnectionUsers`,
  UPDATE_BANK_CONNECTION: `${NETLIFY_FUNCTIONS_BASE}/updateBankConnection`,
  GET_USERS_BASIC: `${NETLIFY_FUNCTIONS_BASE}/getUsersBasic`,
};

/**
 * Retourne l'URL de base pour les fonctions Vercel
 */
const getVercelBaseUrl = () => {
  const env = getEnvironment();

  if (env === 'development') {
    // En développement, pointer vers le serveur Vercel local
    // IMPORTANT: Vous devez lancer `vercel dev --listen 3001` dans un terminal séparé
    return 'http://localhost:3001/api';
  }

  if (env === 'staging') {
    // Staging : utilise le déploiement Vercel de la branche develop
    return 'https://gie-consultants-react-develop.vercel.app/api';
  }

  // Production
  return 'https://gie-consultants-react-oxgrr.vercel.app/api';
};

// URL de base pour les fonctions Vercel (lourdes)
export const VERCEL_FUNCTIONS_BASE = getVercelBaseUrl();

// URLs des fonctions Vercel (lourdes)
export const VERCEL_FUNCTIONS = {
  DOWNLOAD_FACTURE_INTERNE: `${VERCEL_FUNCTIONS_BASE}/download-facture-interne`,
  SEND_FACTURE_EMAIL: `${VERCEL_FUNCTIONS_BASE}/send-facture-email`,
  QONTO_SYNC: `${VERCEL_FUNCTIONS_BASE}/qonto/qonto-sync`,
};

// Export pour debug
export const getApiEnvironment = getEnvironment;
export const getApiBaseUrl = getNetlifyBaseUrl;
export const getVercelApiBaseUrl = getVercelBaseUrl;
